<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('kds.ods')" class="text-left">
              <ods v-if="isOds" :isOds="isOds"></ods>
            </v-tab>
            <v-tab :title="$t('pages.digitalSignage')" class="text-left">
              <digital-signage v-if="isDigitalSignage"></digital-signage>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import Ods from '../OrderScreen/OrderScreen.vue'
  import DigitalSignage from '../OrderScreen/DigitalSignage.vue'
  export default {
    components: {
      Ods,
      DigitalSignage
    },
    data () {
      return {
        isOds: false,
        isDigitalSignage: false
      }
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isOds = false
        this.isDigitalSignage = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('pages.digitalSignage'):
            this.isDigitalSignage = true
            break
          default:
            this.isOds = true
            break
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/OrderScreen/OrderScreenTabs.vue